import React, { useEffect, useState, useCallback } from 'react'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import { Flex } from 'reflexbox'
import { useLazyQuery, useQuery } from '@apollo/react-hooks'
import BreadCrumb from 'ui-components/lib/components/BreadCrumb'
import useSearchTerm from 'ui-components/lib/hooks/useSearchTerm'
import { faWindowClose } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'
import { servicesQueries, clientsQueries, walletQueries, roadmapQueries } from '../../graphql/queries'
import { FinalPrice, Loading } from '../../components'
import SearchSuggestions from './SearchSuggestions'
import QuestionForm from './QuestionForm'
import StatusVariants from './StatusVariants'
import { ReactComponent as Info } from '../../assets/icons/info.svg'
import { ReactComponent as Calender } from '../../assets/icons/calender.svg'
import { ReactComponent as Money } from '../../assets/icons/money.svg'
import alertify from "alertifyjs"
import "alertifyjs/build/css/alertify.css"
import "alertifyjs/build/css/themes/default.css"
import './style.css';
import Modal from "ui-components/lib/components/Modal";
import { useModal } from 'ui-components'
// SVG Icon Components
const LightbulbIcon = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"></path>
    <path d="M9 18h6"></path>
    <path d="M10 22h4"></path>
  </svg>
)

const RocketIcon = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"></path>
    <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"></path>
    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"></path>
    <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
  </svg>
)

const TrendingUpIcon = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
    <polyline points="16 7 22 7 22 13"></polyline>
  </svg>
)

const BarChart3Icon = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 3v18h18"></path>
    <path d="M18 7v11"></path>
    <path d="M13 12v6"></path>
    <path d="M8 16v2"></path>
  </svg>
)

const Building2Icon = ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>
    <path d="M6 12h12"></path>
    <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>
    <path d="M18 12h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2"></path>
    <path d="M10 6h4"></path>
    <path d="M10 10h4"></path>
    <path d="M10 14h4"></path>
    <path d="M10 18h4"></path>
  </svg>
)

alertify.set("notifier", "position", "top-right")

const CloseButton = styled.button`
  padding: 0;
  margin: 0;
  border: 0;
  outline: 0;

  border-radius: 6px;
  background: var(--card-bg);
  color: var(--red-bnz);
  transition: background-color 0.3s ease, color 0.3s ease, opacity 0.3s ease;

  :hover {
    opacity: 0.8;
    background: var(--card-hover-bg);
  }
`

const PurshaseService = (props) => {
  const { subscriptionService } = useParams()
  const location = useLocation()
  const subserviceIdFromUrl = React.useMemo(() => {
    const params = new URLSearchParams(location.search)
    return params.get('subserviceId') || ''
  }, [location.search])

  const [servicesOptions, setServicesOptions] = useState([''])
  const [servicesTypesOptions, setServicesTypesOptions] = useState([''])
  const [subservicesOptions, setSubservicesOptions] = useState([''])

  const [finalPrice, setFinalPrice] = useState('')
  const [extraUrgentDeadline, setExtraUrgentDeadline] = useState(false)
  const [selectedService, setSelectedService] = useState(null)
  const [selectedServiceType, setSelectedServiceType] = useState(null)
  const [selectedSubservice, setSelectedSubservice] = useState(null)
  const [searchResult, setSearchResult] = useState(null)
  const [searchBlur, setSearchBlur] = useState(false)
  const [serviceId,setServiceId] = useState("");
  const [serviceTypeId, setServiceTypeId] = useState("");
  const [subserviceId, setSubserviceId] = useState("");
  const [clientSubscriptionBP, setClientSubscriptionBP] = useState('')
  const [clientSubscriptionIdentifier,setClientSubscriptionIdentifier] = useState('')
  const [useDraft, setUseDraft] = useState(true)
  const [showModalDraft, setShowModalDraft] = useState(true)
  const [loadDraft, setLoadDraft] = useState(false)
  const [roadmap, setRoadmap] = useState({
    selectedRoadmapFirstStepServices: [],
    selectedRoadmapSecondStepServices: [],
    selectedRoadmapThirdStepServices: [],
    selectedRoadmapFourthStepServices: [],
    selectedRoadmapFifthStepServices: []
  })
  const [searchQuery, setSearchQuery] = useState("")

  const { push } = useHistory()
  const { isOpen, openModal, closeModal } = useModal();

  const { data: statusData, loading: statusLoading } = useQuery(clientsQueries.GET_STATUS)
  const { data: servicesOptionsData, loading: servicesOptionsLoading, refetch: fetchServicesOptions } = useQuery(
    servicesQueries.GET_SERVICES_OPTIONS,
    {
      onCompleted() {
        setServicesOptions(servicesOptionsData?.services)
      },
    }
  )

  const { data: dataClientSubscriptionBP } = useQuery(walletQueries.GET_MY_SUBSCRIPTION, {
    variables: {
      subscriptionType: 'planos-bonuz',
      planIdentifier: 'bonuz-plans',
    },
  })

  const { data: dataRoadmap, loading: roadmapLoading } = useQuery(roadmapQueries.GET_ROADMAP)

  const [searchSubserviceFromUrl] = useLazyQuery(servicesQueries.SEARCH_SUBSERVICE, {
    onCompleted(result) {
      const list = result?.searchSubservice
      const subservice = list?.[0]
      if (subservice?.service?._id && subservice?.serviceType?._id) {
        selectSubserviceByHint(subservice.service._id, subservice.serviceType._id, subservice._id)
      }
    },
  })

  useEffect(() => {
    if (subserviceIdFromUrl) {
      searchSubserviceFromUrl({ variables: { search: subserviceIdFromUrl } })
    }
  }, [subserviceIdFromUrl, searchSubserviceFromUrl])

  const [fetchServicesTypesOptions, { data: servicesTypesOptionsData, loading: servicesTypesOptionsLoading }] = useLazyQuery(
    servicesQueries.GET_SERVICESTYPES_OPTIONS,
    {
      variables: {
        serviceId: selectedService?._id,
      },
      onCompleted() {
        setServicesTypesOptions(servicesTypesOptionsData?.servicesTypes)
        if (loadDraft) {
          const serviceTypeData = servicesTypesOptionsData?.servicesTypes.find((serviceType) => serviceType._id === loadDraft.serviceType._id)
          setSelectedServiceType(serviceTypeData)
          setSelectedSubservice(null)
        } else if (serviceTypeId && servicesTypesOptionsData?.servicesTypes) {
          // Se serviceTypeId está definido (clicou nas fases), encontrar e selecionar o tipo
          const serviceTypeData = servicesTypesOptionsData.servicesTypes.find((serviceType) => serviceType._id === serviceTypeId)
          if (serviceTypeData) {
            setSelectedServiceType(serviceTypeData)
            fetchSubservicesOptions({
              variables: {
                typeId: serviceTypeId
              }
            })
          }
        }
      },
    }
  )

  const [fetchSubservicesOptions, { data: subservicesOptionsData, loading: subservicesOptionsLoading }] = useLazyQuery(
    servicesQueries.GET_SUBSERVICES_OPTIONS,
    {
      variables: {
        typeId: selectedServiceType?._id,
      },
      onCompleted() {
        setSubservicesOptions(subservicesOptionsData?.subservices)
        if (loadDraft) {
          const selectedSubservice = loadDraft.subservice._id
          const subserviceData = subservicesOptionsData?.subservices.find((subservice) => subservice._id === selectedSubservice)
          setSelectedSubservice(subserviceData)
        } else if (subserviceId && subservicesOptionsData?.subservices) {
          // Se subserviceId está definido (clicou nas fases), encontrar e selecionar o subserviço
          const subserviceData = subservicesOptionsData.subservices.find((subservice) => subservice._id === subserviceId)
          if (subserviceData) {
            setSelectedSubservice(subserviceData)
          }
        }
      },
    }
  )

  const [searchSubservice, { data: dataSearch, loading: loadingSearch }] = useLazyQuery(servicesQueries.SEARCH_SUBSERVICE, {
    onCompleted() {},
  })

  useEffect(() => {
    fetchServicesOptions()
  }, [fetchServicesOptions])

  useEffect(() => {
    if (selectedService !== null) fetchServicesTypesOptions()
  }, [fetchServicesTypesOptions, selectedService])

  useEffect(() => {
    if (selectedServiceType !== null) fetchSubservicesOptions()
  }, [fetchSubservicesOptions, selectedServiceType])

  useEffect(() => {
    if(dataClientSubscriptionBP && dataClientSubscriptionBP.subscription){
      setClientSubscriptionBP(dataClientSubscriptionBP.subscription.planIdentifier)
      setClientSubscriptionIdentifier(dataClientSubscriptionBP.subscription.planIdentifier)
    }
  }, [dataClientSubscriptionBP]) //eslint-disable-line

  useEffect(() => {
    if(dataRoadmap !== undefined){
      setRoadmap(dataRoadmap?.getRoadmap)
    }
  }, [dataRoadmap])

  const handleServiceSelect = (event) => {
    const selectedServiceId = event.target.value
    const serviceData = servicesOptions.find((service) => service._id === selectedServiceId)

    setSelectedService(serviceData)
    setSelectedServiceType(null)
    setSelectedSubservice(null)
  }

  const handleServiceTypeSelect = (event) => {
    const selectedServiceTypeId = event.target.value
    const serviceTypeData = servicesTypesOptions?.find((serviceType) => serviceType._id === selectedServiceTypeId)
    setSelectedServiceType(serviceTypeData)
    setSelectedSubservice(null)
  }

  const handleSubservicesSelect = (event) => {
    const selectedSubservice = event.target.value
    const subserviceData = subservicesOptions?.find((subservice) => subservice._id === selectedSubservice)
    setSelectedSubservice(subserviceData)
  }

  const selectSubserviceByHint = async (serviceId,serviceType,subserviceId) => {
    console.log('serviceId',serviceId)
    console.log('serviceType',serviceType)
    console.log('subserviceId',subserviceId)
    // Limpar seleções anteriores
    setSelectedService(null)
    setSelectedServiceType(null)
    setSelectedSubservice(null)
    setSearchResult(null)
    setSearchQuery('')
    handleChangeSearchTerm('')
    // Definir os IDs para iniciar o processo de seleção
    setServiceId(serviceId);
    setServiceTypeId(serviceType);
    setSubserviceId(subserviceId);
  }

  // Quando serviceId muda, encontrar o serviço e buscar os tipos
  useEffect(()=>{
    if(serviceId && servicesOptions && servicesOptions.length > 0){
      const serviceData = servicesOptions.find((service) => service._id === serviceId)
      if(serviceData){
        setSelectedService(serviceData)
        // Passar o serviceId diretamente para a query
        fetchServicesTypesOptions({
          variables: {
            serviceId: serviceId
          }
        })
      }
    }
  },[serviceId, servicesOptions, fetchServicesTypesOptions])

  // Quando os tipos de serviço são carregados e serviceTypeId está definido, encontrar o tipo
  useEffect(()=>{
    if(serviceTypeId && servicesTypesOptionsData?.servicesTypes && servicesTypesOptionsData.servicesTypes.length > 0){
      const serviceTypeData = servicesTypesOptionsData.servicesTypes.find((serviceType) => serviceType._id === serviceTypeId)
      if(serviceTypeData && (!selectedServiceType || selectedServiceType._id !== serviceTypeId)){
        setSelectedServiceType(serviceTypeData)
        // Passar o serviceTypeId diretamente para a query
        fetchSubservicesOptions({
          variables: {
            typeId: serviceTypeId
          }
        })
      }
    }
  },[serviceTypeId, servicesTypesOptionsData, fetchSubservicesOptions, selectedServiceType])

  // Quando os subserviços são carregados e subserviceId está definido, encontrar o subserviço
  useEffect(()=>{
    if(subserviceId && subservicesOptionsData?.subservices && subservicesOptionsData.subservices.length > 0){
      const subserviceData = subservicesOptionsData.subservices.find((subservice) => subservice._id === subserviceId)
      if(subserviceData && (!selectedSubservice || selectedSubservice._id !== subserviceId)){
        setSelectedSubservice(subserviceData)
      }
    }
  },[subserviceId, subservicesOptionsData, selectedSubservice])



  const [searchTerm, lazySearchTerm, { handleChangeSearchTerm }] = useSearchTerm('', 400) //eslint-disable-line

  const handleSearchInput = useCallback(
    (value) => {
      if (value === '') setSearchResult(null)
      handleChangeSearchTerm(value)
    },
    [handleChangeSearchTerm]
  )

  useEffect(() => {
    if (searchTerm) {
      searchSubservice({
        variables: { search: searchTerm },
      })

      setSelectedService(null)
      setSelectedServiceType(null)
      setSelectedSubservice(null)
      setSearchQuery(searchTerm)
    } else {
      setSearchQuery("")
    }
  }, [searchTerm, searchSubservice])

  useEffect(() => {
    if (subscriptionService){
      handleSearchInput(subscriptionService)
    }
  }, [subscriptionService]) // eslint-disable-line

  const handleCloseButton = useCallback(() => {
    setSearchResult(null)
    handleChangeSearchTerm('')
    setSearchQuery('')
  }, [handleChangeSearchTerm, setSearchResult])

  const handleFinalPrice = useCallback((price) => {
    setFinalPrice(price)
  },[]) // eslint-disable-line 


  const handleExtraUrgentDemand = useCallback((deadline) => {
    setExtraUrgentDeadline(deadline)
  },[]) // eslint-disable-line
  
  useEffect(() => {
    const draft = () => {
      let stored = localStorage.getItem('new-demand-draft');
      if (stored && !isOpen) {
        openModal()
      }
    }
    if (showModalDraft) {
      draft();
    }
  }, [isOpen, openModal, showModalDraft])

  const handleCloseModal = (discart = false) => {
    setShowModalDraft(false)
    if (discart === true) {
      localStorage.removeItem('new-demand-draft')
    }
    closeModal()
  }

  const handleUseDraft = () => {
    closeModal()
    let stored = localStorage.getItem('new-demand-draft');
    stored = JSON.parse(stored)
    setLoadDraft(
      {
        service: stored.service,
        serviceType: stored.serviceType,
        subservice: stored.subservice
      }
    )
    handleServiceSelect(
      {
        target: {
          value: stored.serviceId
        }
      }
    )
    setUseDraft(true)
    setShowModalDraft(false)
  }

  const navigationLinks = [
    { label: 'Início', onClick: () => push('/dashboard') },
    { label: 'Serviços', onClick: () => push('/dashboard/serviços') },
    { label: 'Solicitar'},
  ]

  const stages = [
    {
      id: "ideacao",
      title: "Fase de Ideação",
      icon: LightbulbIcon,
      color: "stage-ideacao",
      description: "Formalize sua ideia e proteja seu negócio desde o início",
      services: roadmap.selectedRoadmapFirstStepServices || []
    },
    {
      id: "mvp",
      title: "Fase MVP",
      icon: RocketIcon,
      color: "stage-mvp",
      description: "Contratos, termos e planejamento tributário",
      services: roadmap.selectedRoadmapSecondStepServices || []
    },
    {
      id: "tracao",
      title: "Fase de Tração",
      icon: TrendingUpIcon,
      color: "stage-tracao",
      description: "Investimento, compliance e contratos",
      services: roadmap.selectedRoadmapThirdStepServices || []
    },
    {
      id: "escala",
      title: "Fase de Escala",
      icon: BarChart3Icon,
      color: "stage-escala",
      description: "Abertura de empresas e séries de investimento",
      services: roadmap.selectedRoadmapFourthStepServices || []
    },
    {
      id: "consolidado",
      title: "Negócio Estabelecido",
      icon: Building2Icon,
      color: "stage-consolidado",
      description: "Aquisições, renovações e novos produtos",
      services: roadmap.selectedRoadmapFifthStepServices || []
    }
  ]

  const filteredStages = stages.filter(stage => 
    stage.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    stage.services.some(service => (service?.subserviceName || '').toLowerCase().includes(searchQuery.toLowerCase()))
  )

  if (statusLoading || servicesOptionsLoading || roadmapLoading) {
    return <Loading />
  }


  const getStageColorClasses = (colorName) => {
    const colorMap = {
      "stage-ideacao": {
        bg: "bg-stage-ideacao",
        text: "text-stage-ideacao",
        dot: "dot-stage-ideacao"
      },
      "stage-mvp": {
        bg: "bg-stage-mvp",
        text: "text-stage-mvp",
        dot: "dot-stage-mvp"
      },
      "stage-tracao": {
        bg: "bg-stage-tracao",
        text: "text-stage-tracao",
        dot: "dot-stage-tracao"
      },
      "stage-escala": {
        bg: "bg-stage-escala",
        text: "text-stage-escala",
        dot: "dot-stage-escala"
      },
      "stage-consolidado": {
        bg: "bg-stage-consolidado",
        text: "text-stage-consolidado",
        dot: "dot-stage-consolidado"
      }
    }
    return colorMap[colorName] || colorMap["stage-ideacao"]
  }

  return (
    <>
      <Flex width={1} justifyContent="center" flexDirection="column" className="service">
        <Flex width={1} mb={3} className="breadCrumb">
          <BreadCrumb ml={-3} color="primary" navigationLinks={navigationLinks} />
        </Flex>
      </Flex>
      <div className="purchase-service-container">
        <div className="purchase-service-wrapper">
          {/* Header Section */}
          <div className="purchase-service-header">
            <h1 className="purchase-service-title">Solicitar Demanda</h1>
            <p className="purchase-service-subtitle">
              Adquira um pacote de serviços e obtenha sucesso! Solicite um serviço de orçamento com um dos nossos Advogados B.onuz.
            </p>
          </div>

          {/* Search Bar */}
          {statusData?.me?.status !== 'pending_package' && (
            <div className="purchase-service-search">
              <div className="purchase-service-search-wrapper">
                <svg 
                  className="purchase-service-search-icon" 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="m21 21-4.35-4.35"></path>
                </svg>
                <input
                  id="search"
                  name="search"
                  type="text"
                  disabled={subscriptionService ? true : false}
                  placeholder="Buscar por serviços..."
                  value={searchTerm}
                  autoComplete="off"
                  onChange={(event) => {
                    handleSearchInput(event.target.value)
                    setSearchQuery(event.target.value)
                  }}
                  className="purchase-service-search-input"
                  onBlur={() => setSearchBlur(true)}
                  onFocus={() => setSearchBlur(false)}
                />
                {!!searchTerm && (
                  <SearchSuggestions
                    loading={loadingSearch}
                    suggestions={dataSearch?.searchSubservice}
                    setSearchResult={setSearchResult}
                    searchBlur={searchBlur}
                    searchResult={searchResult}
                    searchTerm={searchTerm}
                    setSearchTerm={handleSearchInput}
                    handleChangeSearchTerm={handleChangeSearchTerm}
                  />
                )}
              </div>
              {!!searchResult && !subscriptionService && (
                <div className="purchase-service-clear-search">
                  <CloseButton onClick={handleCloseButton}>
                    <FontAwesomeIcon icon={faWindowClose} style={{ fontSize: '24px' }} />
                    <span style={{ marginLeft: 5 }}>Limpar busca</span>
                  </CloseButton>
                </div>
              )}
            </div>
          )}

          {/* Filters */}
          {statusData?.me?.status !== 'pending_package' && !searchTerm && (serviceId === '' && serviceTypeId === '' && subserviceId === '') && (
            <div className="purchase-service-filters">
              <div className="purchase-service-filter-item">
                <label className="purchase-service-filter-label">Serviços</label>
                <select 
                  className="purchase-service-select"
                  onChange={handleServiceSelect}
                  value={selectedService?._id || ''}
                >
                  <option value="">Selecione um serviço</option>
                  {servicesOptionsLoading ? (
                    <option value="">Carregando...</option>
                  ) : (
                    <>
                      {servicesOptionsData?.services?.map((option) => (
                        <option key={option._id} value={option._id}>
                          {option.name}
                        </option>
                      ))}
                    </>
                  )}
                </select>
              </div>
              <div className="purchase-service-filter-item">
                <label className="purchase-service-filter-label">Tipos</label>
                <select 
                  className="purchase-service-select"
                  onChange={handleServiceTypeSelect}
                  disabled={servicesOptionsLoading || servicesTypesOptionsLoading || !selectedService}
                  value={selectedServiceType?._id || ''}
                >
                  {servicesTypesOptionsLoading ? (
                    <option value="">Carregando...</option>
                  ) : (
                    <>
                      <option value="">Selecione um tipo</option>
                      {selectedService &&
                        servicesTypesOptions?.map((option) => (
                          <option key={option._id} value={option._id}>
                            {option.name}
                          </option>
                        ))}
                    </>
                  )}
                </select>
              </div>
              <div className="purchase-service-filter-item">
                <label className="purchase-service-filter-label">Subserviços</label>
                <select 
                  className="purchase-service-select"
                  onChange={handleSubservicesSelect}
                  disabled={servicesOptionsLoading || servicesTypesOptionsLoading || subservicesOptionsLoading || !selectedServiceType}
                  value={selectedSubservice?._id || ''}
                >
                  {subservicesOptionsLoading ? (
                    <option value="">Carregando...</option>
                  ) : (
                    <>
                      <option value="">Selecione um subserviço</option>
                      {selectedServiceType &&
                        subservicesOptions?.map((option) => (
                          <option key={option._id} value={option._id}>
                            {option.name}
                          </option>
                        ))}
                    </>
                  )}
                </select>
              </div>
            </div>
          )}

          {/* Info Cards */}
          <div className="purchase-service-info-cards">
            <div className="purchase-service-info-card purchase-service-info-card-primary">
              <div className="purchase-service-info-card-icon">
                <svg 
                  className="purchase-service-icon-lightbulb" 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <path d="M9 21h6"></path>
                  <path d="M12 3a6 6 0 0 0 0 12v3"></path>
                  <path d="M12 18v3"></path>
                  <path d="M9 18h6"></path>
                  <path d="M12 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path>
                </svg>
              </div>
              <div className="purchase-service-info-card-content">
                <h3 className="purchase-service-info-card-title">Como funciona?</h3>
                <p className="purchase-service-info-card-text">
                  Clique no serviço desejado. Os serviços já têm débitos específicos. Para demandas que vão para orçamento (sem valor tabelado), enviaremos o valor na área de propostas para você aprovar o débito.
                </p>
              </div>
            </div>

            <div className="purchase-service-info-card purchase-service-info-card-highlight">
              <div className="purchase-service-info-card-icon-large">
                <svg 
                  className="purchase-service-icon-user-circle" 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="28" 
                  height="28" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <div className="purchase-service-info-card-content">
                <div className="purchase-service-info-card-header">
                  <h3 className="purchase-service-info-card-title">Tem dúvidas específicas?</h3>
                  <span className="purchase-service-badge">Popular</span>
                </div>
                <p className="purchase-service-info-card-text">
                  Agende uma consulta de 30 minutos com um advogado especializado
                </p>
                <button 
                  className="purchase-service-button-primary"
                  onClick={() => push('/dashboard/fala-advogado')}
                >
                  Falar com Advogado
                </button>
              </div>
            </div>
          </div>

          {/* Status Variants */}
          {statusData?.me?.status === 'pending_package' && (
            <div className="purchase-service-status">
              <StatusVariants status={statusData.me.status} />
            </div>
          )}

          {/* Stages Grid */}
          {!searchTerm && !searchResult && !selectedService && statusData?.me?.status !== 'pending_package' && (
            <div className="purchase-service-stages">
              <div className="purchase-service-stages-header">
                <div>
                  <h2 className="purchase-service-stages-title">Sugestões de Serviços por Estágio</h2>
                  <p className="purchase-service-stages-subtitle">Escolha a fase da sua empresa e explore os serviços recomendados</p>
                </div>
              </div>
              
              <div className="purchase-service-stages-grid">
                {filteredStages.map((stage, index) => {
                  const colorClasses = getStageColorClasses(stage.color)
                  const IconComponent = stage.icon
                  
                  return (
                    <div key={stage.id} className="purchase-service-stage-card purchase-service-stage-card-group">
                      <div className="purchase-service-stage-card-header">
                        <div className={`purchase-service-stage-card-icon ${colorClasses.bg}`}>
                          <IconComponent className={`purchase-service-stage-icon-svg ${colorClasses.text}`} />
                        </div>
                        <span className="purchase-service-stage-badge">Sugestões</span>
                      </div>
                      
                      <h3 className="purchase-service-stage-card-title">
                        {stage.title}
                      </h3>
                      <p className="purchase-service-stage-card-description">
                        {stage.description}
                      </p>

                      {/* Services List */}
                      {stage.services && stage.services.length > 0 && (
                        <div className="purchase-service-stage-services">
                          {stage.services.map((service, idx) => (
                            <button
                              key={idx}
                              className="purchase-service-stage-service-item purchase-service-stage-service-item-group"
                              onClick={() => {
                                selectSubserviceByHint(service?.serviceId, service?.serviceType, service?.subserviceId)
                              }}
                            >
                              <span className={`purchase-service-stage-service-dot ${colorClasses.dot}`} />
                              <span className="purchase-service-stage-service-name">{service?.subserviceName || ''}</span>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            </div>
          )}

          {/* Empty State */}
          {filteredStages.length === 0 && !searchTerm && !selectedService && (
            <div className="purchase-service-empty">
              <p className="purchase-service-empty-text">Nenhum serviço encontrado com "{searchQuery}"</p>
            </div>
          )}

          {/* Selected Service/Subservice Content */}
          <Flex width={1} flexDirection="column" justifyContent="center" style={{marginTop: '20px'}}>

              {/* {statusData.me.status !== 'pending_package' && !selectedService && !searchTerm && (
                <Alert
                  title="Use os filtros ou o campo de busca para encontrar o serviço que procura"
                  message={'Você pode encontrar serviços específicos para sua necessidade escolhendo entre as opções do filtro acima.'}
                  icon={faArrowCircleUp}
                  iconSize="45px"
                  mt={3}
                />
              )} */}
              {/* {selectedService && !selectedServiceType && (
                <Alert title={selectedService.name} message={selectedService.description} icon={faCopy} iconSize="45px" mt={3} />
              )} */}
              {/* {selectedService && selectedServiceType && !selectedSubservice && (
                <Alert
                  title={`${selectedService.name} - ${selectedServiceType.name}`}
                  message={selectedServiceType.description}
                  icon={faCopy}
                  iconSize="45px"
                  mt={3}
                />
              )} */}
              {!searchTerm && !searchResult && selectedService && selectedServiceType && selectedSubservice && (
                <>
                {selectedSubservice?.clientPrice?.amount ?
                  <>
                    <div className='card card-service'>
                      <div className='card-title'>
                        <h6 style={{margin: "0", padding: "10px 0", color: "var(--text-color)"}}>{`${selectedService.name} - ${selectedServiceType.name} - ${selectedSubservice.name}`}</h6>
                      </div>
                      <div className='card-body'>
                        <p style={{color: 'var(--text-color)'}}><span style={{marginRight: '6px'}}><Calender/></span>
                          {(!extraUrgentDeadline || !selectedSubservice?.urgentDeadline) && (
                            selectedSubservice?.deadline === 1 ? `${selectedSubservice?.deadline} dia útil` : `${selectedSubservice?.deadline} dias úteis`
                          )}
                          {(extraUrgentDeadline && selectedSubservice?.urgentDeadline) && (
                            selectedSubservice?.urgentDeadline === 1 ? `${selectedSubservice?.urgentDeadline} dia útil` : `${selectedSubservice?.urgentDeadline} dias úteis`
                          )}
                        </p>
                        <div id="price-demands">
                          <Money/>
                          <strong style={{color: "var(--red-bnz)"}}>
                            <FinalPrice price={finalPrice} subcriptrionIdentifier={clientSubscriptionIdentifier}/>
                          </strong>
                        </div>
                      </div>
                    </div> 
                    {selectedSubservice.description && (
                      <div className='card card-info my-3' style={{background: 'var(--card-bg)', borderRadius: '16px'}}>
                        <div style={{borderRight: "2px var(--purple-bnz) solid"}}>
                          <Info className='icon'/>
                        </div>
                        <div>
                          <p style={{color: 'var(--text-color)'}}>{selectedSubservice.description}</p>
                        </div>
                      </div>
                    )}
                  </>
                :
                  <>
                    <div className='card card-service'>
                      <div className='card-body'>
                        <h6 style={{margin: "0", padding: "10px 0", color: "var(--text-color)"}}>{`${selectedService.name} - ${selectedServiceType.name} - ${selectedSubservice.name}`}</h6>
                      </div>
                    </div>
                    {selectedSubservice.description && (
                      <div className='card card-info my-3' style={{background: 'var(--card-bg)', borderRadius: '16px'}}>
                        <div style={{borderRight: "2px var(--purple-bnz) solid"}}>
                          <Info className='icon'/>
                        </div>
                        <div>
                          <p style={{color: 'var(--text-color)'}}>{selectedSubservice.description}</p>
                        </div>
                      </div>
                    )}
                    <div className='card card-info my-1' style={{background: 'var(--card-bg)', border: '1px solid var(--purple-bnz)', borderRadius: '8px'}}>
                        <div style={{borderRight: "2px var(--purple-bnz) solid"}}>
                          <Info className='icon'/>
                        </div>
                        <div>
                          <p style={{color: 'var(--text-color)'}}>Este serviço exige um processo de orçamento.{clientSubscriptionBP ? <b> Somente BNZs adquiridos</b> : ''}</p>
                        </div>
                    </div>
                  </>
                }
                  <QuestionForm serviceType={selectedServiceType} service={selectedService} useDraft={useDraft} serviceId={selectedService?._id} subservice={selectedSubservice} handleFinalPrice={handleFinalPrice} handleExtraUrgentDemand={handleExtraUrgentDemand} />
                </>
              )}
              {searchTerm && !!searchResult && (
                <>
                {searchResult?.subservice?.clientPrice?.amount ?
                  <>
                    <div className='card card-service'>
                      <div className='card-title'>
                        <h6 style={{margin: "0", padding: "10px 0", color: "var(--text-color)"}}>{searchTerm}</h6>
                      </div>
                      <div className='card-body'>
                        <p style={{color: 'var(--text-color)'}}><span style={{marginRight: '6px'}}><Calender/></span>
                          {(!extraUrgentDeadline || !searchResult.subservice.urgentDeadline) && (
                            searchResult.subservice.deadline === 1 ? `${searchResult.subservice.deadline} dia útil` : `${searchResult.subservice.deadline} dias úteis`
                          )}
                          {(extraUrgentDeadline && searchResult.subservice.urgentDeadline) && (
                            searchResult.subservice.urgentDeadline === 1 ? `${searchResult.subservice.urgentDeadline} dia útil` : `${searchResult.subservice.urgentDeadline} dias úteis`
                          )}
                        </p>
                        <div id="price-demands">
                          <Money/>
                          <strong style={{color: "var(--red-bnz)"}}>
                            <FinalPrice price={finalPrice} subcriptrionIdentifier={clientSubscriptionIdentifier}/>
                          </strong>
                        </div>
                      </div>
                    </div>
                    {searchResult.subservice.description && (
                      <div className='card card-info my-3' style={{background: 'var(--card-bg)', borderRadius: '16px'}}>
                        <div style={{borderRight: "2px var(--purple-bnz) solid"}}>
                          <Info className='icon'/>
                        </div>
                        <div>
                          <p style={{color: 'var(--text-color)'}}>{searchResult.subservice.description}</p>
                        </div>
                      </div>
                    )}
                  </>
                :
                  <>
                    <div className='card card-service'>
                      <div className='card-body'>
                        <h6 style={{margin: "0", padding: "10px 0", color: "var(--text-color)"}}>{searchTerm}</h6>
                      </div>
                    </div>
                    {searchResult.subservice.description && (
                      <div className='card card-info my-3' style={{background: 'var(--card-bg)', borderRadius: '16px'}}>
                        <div style={{borderRight: "2px var(--purple-bnz) solid"}}>
                          <Info className='icon'/>
                        </div>
                        <div>
                          <p style={{color: 'var(--text-color)'}}>{searchResult.subservice.description}</p>
                        </div>
                      </div>
                    )}
                    <div className='card card-info my-1' style={{background: 'var(--card-bg)', border: '1px solid var(--purple-bnz)', borderRadius: '8px'}}>
                        <div style={{borderRight: "2px var(--purple-bnz) solid"}}>
                          <Info className='icon'/>
                        </div>
                        <div>
                          <p style={{color: 'var(--text-color)'}}>Este serviço exige um processo de orçamento.{clientSubscriptionBP ? <b> Somente BNZs adquiridos</b> : ''}</p>
                        </div>
                    </div>
                  </>
                }
                  <QuestionForm serviceType={searchResult.serviceType} service={searchResult.service} useDraft={useDraft} serviceId={searchResult.serviceId} subservice={searchResult.subservice} handleFinalPrice={handleFinalPrice} handleExtraUrgentDemand={handleExtraUrgentDemand} />
                </>
              )}
            </Flex>

          {/* Contact Card */}
          {!searchTerm && !searchResult && !selectedService && (
            <div className="purchase-service-contact-card">
              <div className="purchase-service-contact-content">
                <div className="purchase-service-contact-icon">
                  <svg 
                    className="purchase-service-icon-message-circle" 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="32" 
                    height="32" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  >
                    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                  </svg>
                </div>
                <h3 className="purchase-service-contact-title">Não achou o que procurava?</h3>
                <p className="purchase-service-contact-text">
                  Nossa equipe está pronta para ajudar você a encontrar a solução jurídica ideal para o seu negócio.
                </p>
                <button 
                  className="purchase-service-button-primary"
                  onClick={() => window.open('https://api.whatsapp.com/send?phone=5511990213852&text=Olá, vim do fale conosco', '_blank')}
                >
                  Fale Conosco
                </button>
              </div>
            </div>
          )}
        </div>
        <Modal
          open={isOpen}
          onClose={closeModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <h3>Rascunho</h3>
          <hr />
          <p className="mt-3">Existe uma solicitação em rascunho, deseja continuar a solicitação?</p>
          <br />
          <div className="mt-3">
            <button className="btn btn-concluid btn-wd-1" onClick={handleUseDraft} style={{marginRight: "15px"}} >Sim</button>
            <button className="btn btn-red btn-wd-1" onClick={handleCloseModal} style={{marginRight: "15px"}}>Não</button>
            <button className="btn btn-cancel btn-wd-1" onClick={() => handleCloseModal(true)}>Descartar</button>
          </div>
        </Modal>
      </div>
    </>
  )
}

export default PurshaseService
